import Head from "next/head";
import Script from "next/script";

export function ExternalWidgetPeekContent() {
    const date = new Date();
    const stamp = date.getMonth() + "-" + date.getDate();

    const scriptSrc = new URL("https://js.peek.com/widget_button.js");
    scriptSrc.searchParams.set("ts", stamp);

    const stylesSrc = new URL("https://js.peek.com/widget_button.css");
    stylesSrc.searchParams.set("ts", stamp);

    return (
        <>
            <Head>
                <link href={stylesSrc.toString()} id="peek-book-button-css" rel="stylesheet" type="text/css" />
            </Head>
            <Script id="peek-book-button-js" src={scriptSrc.toString()} />
        </>
    );
}
